const debounce = (func, wait, immediate) => {
  let timeout, result;

  const later = (context, args) => {
    timeout = null;
    !immediate && (result = func.apply(context, args));
  };

  const debounced = (...args) => {
    timeout && clearTimeout(timeout);
    if (immediate) {
      const callNow = !timeout;
      timeout = setTimeout(later, wait);
      callNow && (result = func.apply(this, args));
    } else {
      timeout = setTimeout(() => func(null, [this, args]), wait);
    }

    return result;
  };

  debounced.cancel = () => {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
};

export default debounce;
